import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import terbilang from '@develoka/angka-terbilang-js'
 
pdfMake.vfs = pdfFonts.pdfMake.vfs;
 
const toRupiah = (num) =>
  `Rp.${num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
 
const formatName = (nama) => {
  if (!nama) return null;
  if (nama.length <= 15) {
    return nama.split(' ').map(w => w ? w[0].toUpperCase() + w.slice(1) : '').join(' ');
  }
  return (
    nama.slice(0, 13).split(' ').map(w => w ? w[0].toUpperCase() + w.slice(1) : '').join(' ') + '.'
  );
};
 
const toBase64 = (url, headers = {}) =>
  fetch(url, { headers })
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror  = reject;
          reader.readAsDataURL(blob);
        })
    );
 
const charBoxes = (value, minLength = 10) => {
  const chars = value ? value.split('') : [];
  const len   = Math.max(chars.length, minLength);
  return Array.from({ length: len }, (_, i) => ({
    text:      chars[i] || '',
    alignment: 'center',
    border:    [true, true, true, true],
    fontSize:  7,
    width:     12,
  }));
};
 
const chkCell = (checked) => ({
  text:      checked ? 'V' : '',
  alignment: 'center',
  border:    [true, true, true, true],
  fontSize:  7,
  width:     12,
});
 
const noBorder = { border: [false, false, false, false] };
 
const buildApprovalHeader = (label) => ({
  text:      label,
  bold:      true,
  alignment: 'center',
  fontSize:  7,
  border:    [true, true, true, true],
  fillColor: '#f2f2f2',
  margin:    [2, 3, 2, 3],
});
 
const buildApprovalBody = (item) => {
  const border = [true, true, true, true];
 
  if (!item) {
    return {
      stack: [
        { text: '\n\n-\n\n-', alignment: 'center', fontSize: 7 },
      ],
      border,
      margin: [2, 4, 2, 4],
    };
  }
 
  const name    = formatName(item.nama);
  const date    = moment(item.updatedAt).format('DD/MM/YYYY');
  const status  = item.status === 0 ? `Reject (${date})` : item.status === 1 ? `Approve (${date})` : '-';
  const jabatan = item.jabatan ? item.jabatan.toUpperCase() : '-';
 
  return {
    stack: [
      { text: status,      alignment: 'center', fontSize: 6, margin: [0, 4, 0, 0] },
      { text: '\n' },
      { text: name || '-', alignment: 'center', fontSize: 7 },
      { text: jabatan,     alignment: 'center', fontSize: 6 },
    ],
    border,
    margin: [2, 4, 2, 4],
  };
};
 
export const downloadFormPDF = async (props) => {
  const { dataApp, detailIo, infoApp, dataTemp = [] } = props.pengadaan;
  const { detailData, typeCost, costCenter }           = props.data;
  const dataDepo = props.depo?.dataDepo || [];
 
  const finalData = typeCost === 'MULTIPLE' ? detailData : detailIo;
  const isAsset   = finalData[0]?.status_form === '8';
 
  const splitApp     = infoApp?.info ? infoApp.info.split(']') : [];
  const penyetujuApp = splitApp[2] || '';
  const cekKode      = finalData[0]?.kode_plant?.length > 4 ? 9 : 5;
 
  const total = finalData.reduce(
    (sum, item) => sum + parseInt(item.price) * parseInt(item.qty),
    0
  );
 
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
  let logoBase64 = null;
  try {
    const token = localStorage.getItem('token')

    logoBase64 = await toBase64(
      `${REACT_APP_BACKEND_URL}/masters/logo.png`,
      { Authorization: `Bearer ${token}` }
    )

  } catch (e) {
    console.warn('Logo gagal dimuat:', e);
  }
 
  const buatList    = dataApp.pembuat   || [];
  const periksaList = dataApp.pemeriksa || [];
  const setujuList  = dataApp.penyetuju || [];
 
  if (!buatList.length)    buatList.push(null);
  if (!periksaList.length) periksaList.push(null);
  if (!setujuList.length)  setujuList.push(null);
 
  const approvalHeaderRow = [
    ...buatList.map(()    => buildApprovalHeader('Dibuat oleh,')),
    ...periksaList.map(() => buildApprovalHeader('Diperiksa oleh,')),
    ...setujuList.map(()  => buildApprovalHeader('Disetujui oleh,')),
  ];
 
  const approvalBodyRow = [
    ...buatList.map((item)    => buildApprovalBody(item)),
    ...periksaList.map((item) => buildApprovalBody(item)),
    ...setujuList.map((item)  => buildApprovalBody(item)),
  ];
 
  const approvalWidths = approvalHeaderRow.map(() => '*');
 
  const ioRow = charBoxes(finalData[0]?.no_io || '', 10);
  const ccRow = charBoxes(costCenter           || '', 10);
  const pcRow = charBoxes(finalData[0]?.depo?.profit_center || '', 10);
 
  const terbilangStr = terbilang(total)
    .split(' ')
    .map((e) => e.charAt(0).toUpperCase() + e.slice(1))
    .join(' ');
 
  const kategori = finalData[0]?.kategori || '';
 
  const budgetedApprover    = cekKode === 5
    ? penyetujuApp.split(';')[1] || ''
    : penyetujuApp.split(';')[3] || '';
  const nonBudgetedApprover = cekKode === 5
    ? penyetujuApp.split(';')[2] || ''
    : penyetujuApp.split(';')[4] || '';
 
  const area    = finalData[0]?.area  || '';
  const tglIo   = finalData[0]?.tglIo || new Date();
  const dateStr = `${area}, ${moment(tglIo).format('DD MMMM YYYY')}`;
 
  const itemHeader = [
    { text: 'Qty',          alignment: 'center', bold: true, fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 8 },
    { text: 'Description',  alignment: 'center', bold: true, fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 8 },
    { text: 'Price/unit',   alignment: 'center', bold: true, fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 8 },
    { text: 'Total Amount', alignment: 'center', bold: true, fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 8 },
  ];
 
  const itemRows = finalData.map((item) => [
    { text: String(item.qty),                                    alignment: 'center', border: [true,true,true,true], fontSize: 8 },
    { text: item.nama,                                           alignment: 'center', border: [true,true,true,true], fontSize: 8 },
    { text: toRupiah(parseInt(item.price)),                      alignment: 'center', border: [true,true,true,true], fontSize: 8 },
    { text: toRupiah(parseInt(item.price) * parseInt(item.qty)), alignment: 'center', border: [true,true,true,true], fontSize: 8 },
  ]);
 
  const docDefinition = {
    pageSize:        'A4',
    pageOrientation: 'portrait',
    pageMargins:     [30, 30, 30, 35],
 
    footer: (currentPage, pageCount) => ({
      text:      `Halaman ${currentPage} dari ${pageCount}`,
      alignment: 'center',
      fontSize:  7,
      margin:    [0, 8, 0, 0],
    }),
 
    content: [
 
      // ── Header: Logo + Judul ─────────────────────────────
      {
        columns: [
          logoBase64
            ? { image: logoBase64, width: 45, height: 55, margin: [0, 0, 8, 0] }
            : { text: '', width: 53 },
          {
            text:      'FORM INTERNAL ORDER ASSET',
            style:     'title',
            alignment: 'center',
            margin:    [0, 14, 0, 0],
          },
        ],
        margin: [0, 0, 0, 14],  // ← lebih longgar
      },
 
      // ── IO Type ──────────────────────────────────────────
      { text: 'IO Type :', bold: true, fontSize: 8, margin: [0, 0, 0, 5] },
      {
        columns: [
          {
            table: { body: [[{ text: 'X', alignment: 'center', border: [true,true,true,true], fontSize: 7, width: 12 }]] },
            layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
            width: 'auto',
          },
          { text: '  CB-20 IO Capex', fontSize: 8, margin: [4, 1, 0, 0] },
        ],
        margin: [0, 0, 0, 12],  // ← lebih longgar
      },
 
      // ── Nomor IO ─────────────────────────────────────────
      {
        columns: [
          { text: 'Nomor IO', width: 65, fontSize: 8, margin: [0, 2, 0, 0] },
          { text: ':',        width: 8,  fontSize: 8, margin: [0, 2, 0, 0] },
          {
            table: { body: [ioRow] },
            layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          },
        ],
        margin: [0, 0, 0, 12],  // ← lebih longgar
      },
 
      // ── Deskripsi / Tabel Item ────────────────────────────
      {
        columns: [
          { text: 'Deskripsi', width: 65, fontSize: 8, margin: [0, 2, 0, 0] },
          { text: ':',         width: 8,  fontSize: 8, margin: [0, 2, 0, 0] },
          {
            table: {
              headerRows: 1,
              widths:     [35, '*', 90, 90],
              body:       [itemHeader, ...itemRows],
            },
            layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          },
        ],
        margin: [0, 0, 0, 12],  // ← lebih longgar
      },
 
      // ── Cost Centre ───────────────────────────────────────
      {
        columns: [
          { text: 'Cost Centre',  width: 65, fontSize: 8, margin: [0, 2, 0, 0] },
          { text: ':',            width: 8,  fontSize: 8, margin: [0, 2, 0, 0] },
          {
            table: { body: [ccRow] },
            layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          },
        ],
        margin: [0, 0, 0, 12],  // ← lebih longgar
      },
 
      // ── Profit Centre ─────────────────────────────────────
      {
        columns: [
          { text: 'Profit Centre', width: 65, fontSize: 8, margin: [0, 2, 0, 0] },
          { text: ':',             width: 8,  fontSize: 8, margin: [0, 2, 0, 0] },
          {
            table: { body: [pcRow] },
            layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          },
        ],
        margin: [0, 0, 0, 12],  // ← lebih longgar
      },
 
      // ── Kategori Budget ───────────────────────────────────
      {
        columns: [
          { text: 'Kategori Budget', width: 65, fontSize: 8, margin: [0, 2, 0, 0] },
          { text: ':',               width: 8,  fontSize: 8, margin: [0, 2, 0, 0] },
          {
            table: {
              body: [[
                chkCell(kategori === 'budget'),
                { text: 'Budget',        ...noBorder, fontSize: 8, margin: [3, 1, 6, 0] },
                chkCell(kategori === 'non-budget'),
                { text: 'Non Budgeted',  ...noBorder, fontSize: 8, margin: [3, 1, 6, 0] },
                chkCell(kategori === 'return'),
                { text: 'Return',        ...noBorder, fontSize: 8, margin: [3, 1, 0, 0] },
              ]],
            },
            layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
          },
        ],
        margin: [0, 0, 0, 12],  // ← lebih longgar
      },
 
      // ── Amount ────────────────────────────────────────────
      {
        columns: [
          { text: 'Amount', width: 65, fontSize: 8, margin: [0, 2, 0, 0] },
          { text: ':',      width: 8,  fontSize: 8, margin: [0, 2, 0, 0] },
          {
            stack: [
              { text: toRupiah(total), bold: true, fontSize: 8 },
              { text: `Terbilang ( ${terbilangStr} Rupiah )`, fontSize: 7, italics: true },
            ],
          },
        ],
        margin: [0, 0, 0, 12],  // ← lebih longgar
      },
 
      // ── Alasan ────────────────────────────────────────────
      {
        columns: [
          { text: 'Alasan', width: 65, fontSize: 8, margin: [0, 2, 0, 0] },
          { text: ':',      width: 8,  fontSize: 8, margin: [0, 2, 0, 0] },
          { text: finalData[0]?.alasan || '-', fontSize: 8 },
        ],
        margin: [0, 0, 0, 16],  // ← lebih longgar sebelum tanggal
      },
 
      // ── Tanggal ───────────────────────────────────────────
      { text: dateStr, fontSize: 8, margin: [0, 0, 0, 12] },  // ← lebih longgar
 
      // ── Tabel Approval ────────────────────────────────────
      {
        table: {
            widths: approvalWidths,
            body: [
            // Baris 1: Group header (Dibuat oleh, Diperiksa oleh, Disetujui oleh)
            [
                // "Dibuat oleh" — span sejumlah buatList
                {
                text: 'Dibuat oleh,',
                bold: true,
                alignment: 'center',
                fontSize: 7,
                fillColor: '#f2f2f2',
                border: [true, true, true, true],
                margin: [2, 3, 2, 3],
                colSpan: buatList.length,
                },
                // filler cells untuk sisa kolom buatList (colSpan - 1)
                ...Array(buatList.length - 1).fill({ text: '', border: [false,false,false,false] }),

                // "Diperiksa oleh" — span sejumlah periksaList
                {
                text: 'Diperiksa oleh,',
                bold: true,
                alignment: 'center',
                fontSize: 7,
                fillColor: '#f2f2f2',
                border: [true, true, true, true],
                margin: [2, 3, 2, 3],
                colSpan: periksaList.length,
                },
                ...Array(periksaList.length - 1).fill({ text: '', border: [false,false,false,false] }),

                // "Disetujui oleh" — span sejumlah setujuList
                {
                text: 'Disetujui oleh,',
                bold: true,
                alignment: 'center',
                fontSize: 7,
                fillColor: '#f2f2f2',
                border: [true, true, true, true],
                margin: [2, 3, 2, 3],
                colSpan: setujuList.length,
                },
                ...Array(setujuList.length - 1).fill({ text: '', border: [false,false,false,false] }),
            ],

            // Baris 2: isi nama, status, jabatan (per orang)
            approvalBodyRow,
            ],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
        margin: [0, 0, 0, 16],
        },

 
      // ── Keterangan ────────────────────────────────────────
      { text: 'Keterangan :',                                                              bold: true,  fontSize: 8 },
      { text: 'No. IO dan Profit Center diisi oleh Budgeting Department',                  fontSize: 7, margin: [0, 4, 0, 0] },
      { text: 'Cost Center diisi oleh Asset Department',                                   fontSize: 7, margin: [0, 4, 0, 0] },
      { text: 'Untuk kategori Non Budgeted dan Return kolom alasan "Wajib" diisi',         fontSize: 7, margin: [0, 4, 0, 0] },
      { text: '* Sesuai Matriks Otorisasi, disetujui oleh :',                              fontSize: 7, margin: [0, 4, 0, 0] },
      { text: `  - Budgeted / Return : ${budgetedApprover}`,    fontSize: 7, margin: [8, 4, 0, 0] },
      { text: `  - Non Budgeted : ${nonBudgetedApprover}`,      fontSize: 7, margin: [8, 4, 0, 0] },
 
      // ── Nomor Form ────────────────────────────────────────
      { text: 'FRM-FAD-058 REV 06', fontSize: 7, margin: [0, 12, 0, 0] },
    ],
 
    styles: {
      title: {
        bold:       true,
        fontSize:   12,
        decoration: 'underline',
      },
    },
 
    defaultStyle: {
      fontSize: 8,
      font:     'Roboto',
    },
  };
 
  // ── Halaman ke-2: List No.Aset ────────────────────────────
  if (isAsset && dataTemp.length > 0) {
    const assetHeader = [
      'NO','No Pengadaan','Description','Price/unit','Total Amount',
      'No Asset','Cost Center','Profit Center','Area','No IO','ID Asset',
    ].map((h) => ({
      text: h, bold: true, alignment: 'center',
      fillColor: '#f2f2f2', border: [true,true,true,true], fontSize: 7,
    }));
 
    const assetRows = dataTemp.map((item, index) => {
      const found = dataDepo.find((x) => x.kode_plant === item.kode_plant) || {};
      return [
        index + 1,
        item.no_pengadaan,
        item.nama,
        `Rp ${parseInt(item.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`,
        `Rp ${(parseInt(item.price) * parseInt(item.qty)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`,
        item.no_asset       || '',
        found.cost_center   || '',
        found.profit_center || '',
        found.nama_area     || '',
        item.no_io          || '',
        String(item.id),
      ].map((v) => ({
        text: String(v ?? ''), border: [true,true,true,true], fontSize: 6,
      }));
    });
 
    docDefinition.content.push(
      { text: '', pageBreak: 'before' },
      { text: 'List No. Aset', bold: true, fontSize: 10, margin: [0, 0, 0, 6] },
      {
        table: {
          headerRows: 1,
          widths: ['auto','auto','*','auto','auto','auto','auto','auto','auto','auto','auto'],
          body:   [assetHeader, ...assetRows],
        },
        layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5 },
      }
    );
  }
 
  const fileName = `Form Internal Order Asset ${finalData[0]?.no_pengadaan ?? ''} ${moment().format('DD MMMM YYYY')}.pdf`;
 
  return new Promise((resolve, reject) => {
    try {
      pdfMake.createPdf(docDefinition).download(fileName, () => resolve(fileName));
    } catch (err) {
      reject(err);
    }
  });
};